import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ExtensionRequest =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ExtensionRequest, _BaseData);

  function ExtensionRequest() {
    _classCallCheck(this, ExtensionRequest);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExtensionRequest).call(this, "ExtensionRequest"));
  }

  _createClass(ExtensionRequest, [{
    key: "EmailReviewComplete",
    value: function () {
      var _EmailReviewComplete = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(extensionRequestId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.post("/api/".concat(this._controller, "/EmailReviewComplete/").concat(extensionRequestId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function EmailReviewComplete(_x) {
        return _EmailReviewComplete.apply(this, arguments);
      }

      return EmailReviewComplete;
    }()
  }]);

  return ExtensionRequest;
}(BaseData);

export default new ExtensionRequest();